import React from "react";
import { createPortal } from "react-dom";
import "./PopupPortal.scss";

interface Props {
  children: React.ReactNode;
}

/**
 * PopupPortal
 *
 * A portal wrapper that renders popup content into a dedicated DOM node
 * (`#popup-portal`) that lives in the Layout component. This ensures all
 * popups share the same stacking context, avoiding z-index and positioning
 * issues caused by rendering in different parts of the DOM tree.
 *
 * The `#popup-portal` div must exist in the DOM (rendered by Layout).
 *
 * @example
 * <PopupPortal>
 *   <HelpTipsPopup />
 * </PopupPortal>
 */
export const PopupPortal: React.FC<Props> = ({ children }) => {
  const portalTarget = document.getElementById("popup-portal");

  if (!portalTarget) {
    return <>{children}</>;
  }

  return createPortal(children, portalTarget);
};
